import { render, staticRenderFns } from "./device2.vue?vue&type=template&id=4a894196&scoped=true&"
import script from "./device2.vue?vue&type=script&lang=js&"
export * from "./device2.vue?vue&type=script&lang=js&"
import style0 from "./device2.vue?vue&type=style&index=0&id=4a894196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a894196",
  null
  
)

export default component.exports